module.exports = __webpack_public_path__ + "static/media/1025995.9f7b754a.jpg";